import { DateTime } from 'luxon';
export var getScheduleDayData = function (_a) {
    var _b;
    var swapSchedule = _a.swapSchedule, swapFromShiftStart = _a.swapFromShiftStart;
    var swapFromDateFromShiftStart = DateTime.fromISO(swapFromShiftStart).toISODate();
    var swapFromScheduleDay = swapSchedule === null || swapSchedule === void 0 ? void 0 : swapSchedule.scheduleDays.find(function (swapScheduleDay) {
        return swapScheduleDay.timeRange.start === swapFromShiftStart;
    });
    var allScheduleDaysForDay = (swapSchedule === null || swapSchedule === void 0 ? void 0 : swapSchedule.scheduleDays.filter(function (swapScheduleDay) {
        return swapScheduleDay.date === swapFromDateFromShiftStart;
    })) || [];
    var swappableDays = (_b = swapFromScheduleDay === null || swapFromScheduleDay === void 0 ? void 0 : swapFromScheduleDay.swappableDays) !== null && _b !== void 0 ? _b : [];
    var noSwapsAvailable = !swappableDays.length;
    return {
        swapFromScheduleDay: swapFromScheduleDay,
        allScheduleDaysForDay: allScheduleDaysForDay,
        swappableDays: swappableDays,
        noSwapsAvailable: noSwapsAvailable
    };
};
